module.exports = Object.freeze([
	{ label: 'Active', key: 'active', order: 0 },
	{ label: 'Archived', key: 'archived', order: 1 },
	{ label: 'Prospective', key: 'prospective', order: 2},
	{ label: 'Do Not Call', key: 'DNC', order: 3},

]);


//////////////////
// WEBPACK FOOTER
// ../server/constants/statuses/user-statuses.js
// module id = 296
// module chunks = 0